// src/pages/ContractStatus.js
import React, { useState, useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
import TabContext from "@/contexts/TabContext";
import { contractStatusOptions, orderTypeOptions, branchTypeOptions } from "@/constants/selectOptions";
import { useListPageFilter, dateFormatToISOString, dateFormatDateTime, comma } from "@/utils";
import { PageTabs, Pagination, Toast, Confirm } from "@/components";
import DatePicker from "react-datepicker";
import ko from "date-fns/locale/ko";
import Select from "react-select";
import { useGetContractGroupListAdminQuery } from "../../redux/adminContractApi";
import { rolesOptions } from "../../constants/selectOptions";

// 페이지 기본 필터
const pageFilter = {
    parameters: {
        page: 0,
        size: 20,
        query: "",
        contract_status_in: "",
        started_at: "",
        ended_at: "",
    },
};

export const AdminContractStatus = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state: tabs, dispatch } = useContext(TabContext);

    // 탭(토글) 상태: "create" / "signature"
    const [currentTab, setCurrentTab] = useState("create");

    // formData에 pageFilter와 팝업/토스트 상태 등을 넣음
    const { formData, handleChange, setFormData, parameters, toastMsg } = useListPageFilter(pageFilter, {
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        contractRegisterGuidePopupStatus: false,
        triggerSearch: false,
    });

    const { confirmStatus, contractRegisterGuidePopupStatus, triggerSearch } = formData;

    // 탭 추가 로직 (VehicleGarage 예시와 동일)
    useEffect(() => {
        const handleTabAdd = () => {
            const existingTab = tabs.find((tab) => tab.url.split("?")[0] === location.pathname);
            if (!existingTab) {
                dispatch({
                    type: "ADD_TAB",
                    payload: { url: location.pathname + location.search, title: "계약 목록" },
                });
            }
        };
        handleTabAdd();
    }, [dispatch, location.pathname, location.search, tabs]);

    const { data: createData, error: errorCreate } = useGetContractGroupListAdminQuery(parameters, {
        //skip: currentTab !== "create",
        refetchOnMountOrArgChange: true,
        skip: !triggerSearch,
    });

    const signatureParams = {
        ...parameters,
        contract_status_in: "SEND_FINISH,SIGN_FINISH",
    };

    const { data: signatureData, error: errorSignature } = useGetContractGroupListAdminQuery(signatureParams, {
        //skip: currentTab !== "signature",
        refetchOnMountOrArgChange: true,
        skip: !triggerSearch,
    });

    // 아래처럼 데이터/로딩/에러를 분기 처리
    const data = currentTab === "create" ? createData : signatureData;
    const error = currentTab === "create" ? errorCreate : errorSignature;

    // 컴포넌트 마운트 시 초기 데이터 조회
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            triggerSearch: true,
        }));
    }, []);
    // 검색 버튼 클릭
    const handleSearch = () => {
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, page: 0 },
            triggerSearch: true,
        }));
    };

    // 삭제 버튼
    const handleDelete = () => {
        setFormData((prev) => ({
            ...prev,
            confirmStatus: {
                confirmPopupStatus: true,
                confirmTitle: "서명 요청 취소",
                confirmDescription: "해당 계약서를 삭제 하시겠습니까?",
                confirmButtons: [
                    { label: "예", className: "btn-primary", onClick: console.log("삭제") },
                    {
                        label: "아니오",
                        className: "btn-cancel",
                        onClick: () =>
                            setFormData((prev2) => ({
                                ...prev2,
                                confirmStatus: { confirmPopupStatus: false },
                            })),
                    },
                ],
            },
        }));
    };

    useEffect(() => {
        console.log(data);
    }, [data]);

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}

            <div className="management container">
                <PageTabs />

                <div className="table-container">
                    <div className="table-head">
                        <span className="head-tit">계약 목록</span>
                        <div className="breadcrumbs">
                            <ul>
                                <li className="home"></li>
                                <li>ERP 관리</li>
                                <li>계약 목록</li>
                            </ul>
                        </div>
                    </div>
                    <TableFilter formData={formData} handleChange={handleChange} setFormData={setFormData} handleSearch={handleSearch} />

                    <div className="table-content">
                        <div className="table-option">
                            <div className="table-caption">
                                {/* <div className="toggle-list">
                                    <button
                                        type="button"
                                        className={`btn-toggle ${currentTab === "create" ? "active" : ""}`}
                                        onClick={() => setCurrentTab("create")}
                                    >
                                        작성 목록
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn-toggle ${currentTab === "signature" ? "active" : ""}`}
                                        onClick={() => setCurrentTab("signature")}
                                    >
                                        서명 요청
                                    </button>
                                </div> */}
                                <span className="data-count">
                                    전체 <b>{data?.pagination?.totalElements}</b>건{" "}
                                </span>
                            </div>
                            <div className="table-buttons"></div>
                        </div>

                        <div className="table-wrapper">
                            <div className="table">
                                {/* currentTab === 'create' */}
                                {currentTab === "create" && (
                                    <table>
                                        <colgroup>
                                            <col width="7%" />
                                            <col width="7%" />
                                            <col width="7%" />
                                            <col width="7%" />
                                            <col width="7%" />
                                            <col width="7%" />
                                            <col width="7%" />
                                            <col width="6%" />
                                            <col width="8%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">회원 ID</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">회원 구분</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">계약번호</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">계약유형</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">등록일</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">지역</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">차량번호</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">차량정보</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">고객명</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">연락처</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">작성자</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">상태</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">관리</span>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data && data.data && data.data.length > 0 ? (
                                                data.data.map((item, index) => {
                                                    const contracts = item.contracts || [];
                                                    const firstContract = contracts[0];
                                                    const additionalCount = contracts.length > 1 ? contracts.length - 1 : 0;

                                                    return (
                                                        <tr key={index} className={item.orderId ? "call-contract" : ""}>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span className="cell-desc">{item.writer?.loginId || ""}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span className="cell-desc">
                                                                        {item.writer?.roles
                                                                            ?.map(
                                                                                (role) => rolesOptions.find((e) => e.value === role)?.label
                                                                            )
                                                                            .join(", ")}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span className="cell-desc">{item.serialNumber}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span
                                                                        className={`cell-tag tag-box ${
                                                                            orderTypeOptions.find(
                                                                                (option) => option.value === item?.contractType
                                                                            )?.tagColor || ""
                                                                        }`}
                                                                    >
                                                                        {orderTypeOptions.find(
                                                                            (option) => option.value === item?.contractType
                                                                        )?.label || "미확정"}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span className="cell-desc">
                                                                        {dateFormatDateTime(item?.createdAt, "YYYY-MM-DD HH:mm")}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span className="cell-desc">
                                                                        {item.writer?.firstAddressCode?.name || ""}{" "}
                                                                        {item.writer?.secondAddressCode?.name || ""}{" "}
                                                                        {item.writer?.branchType &&
                                                                            `(${
                                                                                branchTypeOptions?.find(
                                                                                    (option) => option.value === item.writer?.branchType
                                                                                )?.label
                                                                            })`}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span className="cell-desc">
                                                                        {firstContract?.contractCar?.carNumber}
                                                                        {additionalCount > 0 && ` 외 ${additionalCount}대`}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="left">
                                                                    <span className="cell-desc">
                                                                        {firstContract?.contractCar?.modelDetailName} (
                                                                        {comma(firstContract?.contractCar?.displacement)}cc)
                                                                        {additionalCount > 0 && ` 외 ${additionalCount}대`}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span className="cell-desc">{item?.customerName}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span className="cell-desc">{item?.customerPhone}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span className="cell-tag">{item?.writer?.name}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    {(() => {
                                                                        const status = contractStatusOptions.find(
                                                                            (e) => e.value === item?.contractStatus
                                                                        );
                                                                        return (
                                                                            <span className={`cell-tag ${status?.txtColor || ""}`}>
                                                                                {status?.label ?? "-"}
                                                                            </span>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn-cell btn-outline"
                                                                        onClick={() => navigate(`/erp/contract/edit/${item?.id}`)}
                                                                    >
                                                                        상세보기
                                                                    </button>
                                                                    {/* <button
                                                                    type="button"
                                                                    className="btn-cell btn-third"
                                                                    onClick={() => {
                                                                        window.open(`/contract/preview/${item?.id}`, "_blank");
                                                                    }}
                                                                >
                                                                    계약서 보기
                                                                </button> */}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="10" className="data-empty">
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">데이터가 없습니다.</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>

                        {data && data.pagination && data.data && data.data.length > 0 && (
                            <Pagination pagination={data.pagination} setFormData={setFormData} />
                        )}
                    </div>
                </div>
            </div>

            {/* Confirm 팝업 */}
            {confirmStatus?.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={confirmStatus.confirmTitle}
                    description={confirmStatus.confirmDescription}
                    buttons={confirmStatus.confirmButtons}
                />
            )}

            {contractRegisterGuidePopupStatus && (
                <ContractRegisterGuidePopup
                    popupStatus={contractRegisterGuidePopupStatus}
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, contractRegisterGuidePopupStatus: false }))}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                />
            )}
        </>
    );
};

const TableFilter = ({ formData, setFormData, handleSearch }) => {
    const [filterOption, setFilterOption] = useState([]);
    const [clientLabel, setClientLabel] = useState({});
    const [statusLabel, setStatusLabel] = useState({});

    const { parameters } = formData;
    const [activeButton, setActiveButton] = useState(null);

    // const { data, error, isLoading } = useGetClientNameListQuery();

    // useEffect(() => {
    //     if (data?.data) {
    //         var res = [{ value: null, label: "전체" }];
    //         data?.data?.forEach((i) => {
    //             res.push({ value: i.id, label: i.clientCorName });
    //         });
    //         setFilterOption(res);
    //     }
    // }, [data]);

    const handleParameterChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                [name]: value,
            },
            triggerSearch: false,
        }));
    };

    const handleDateChange = (dates, type) => {
        const [start, end] = dates;

        if (type === "create") {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    started_at: start ? dateFormatToISOString(start, "start") : "",
                    ended_at: end ? dateFormatToISOString(end, "end") : "",
                },
                triggerSearch: false,
            }));
        }

        if (type === "service") {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    reserveDateStart: start ? dateFormatToISOString(start, "start") : "",
                    reserveDateEnd: end ? dateFormatToISOString(end, "end") : "",
                },
                triggerSearch: false,
            }));
        }

        setActiveButton(null);
    };

    const setDateRange = (days, buttonIndex) => {
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - days);

        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                page: 0,
                started_at: dateFormatToISOString(start, "start"),
                ended_at: dateFormatToISOString(now, "end"),
            },
            triggerSearch: false,
        }));

        setActiveButton(buttonIndex);
    };

    return (
        <div className="table-filter">
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-head">
                        <span className="head-tit">계약 상태 :</span>
                    </div>
                    <div className="item-content">
                        <div className="item-select">
                            <Select
                                options={contractStatusOptions}
                                className="filter-select"
                                classNamePrefix="filter-select"
                                isSearchable={false}
                                placeholder="진행현황"
                                value={statusLabel}
                                onChange={(option) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        parameters: {
                                            ...prev.parameters,
                                            contract_status_in: option.value,
                                        },
                                    }));
                                    setStatusLabel(option);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="filter-item">
                    <div className="item-head">
                        <span className="head-tit">등록일 :</span>
                    </div>
                    <div className="item-content">
                        <div className="item-input">
                            <DatePicker
                                locale={ko}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={20}
                                dateFormat="yyyy.MM.dd"
                                onKeyDown={(e) => e.preventDefault()}
                                selectsRange={true}
                                startDate={parameters.started_at ? new Date(parameters.started_at) : null}
                                endDate={parameters.ended_at ? new Date(parameters.ended_at) : null}
                                onChange={(e) => handleDateChange(e, "create")}
                            />
                        </div>
                    </div>
                </div>
                <div className="filter-item">
                    <div className="item-content">
                        <div className="item-buttons">
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 0 ? "active" : ""}`}
                                onClick={() => setDateRange(0, 0)}
                            >
                                당일
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 15 ? "active" : ""}`}
                                onClick={() => setDateRange(15, 15)}
                            >
                                15일
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 30 ? "active" : ""}`}
                                onClick={() => setDateRange(30, 30)}
                            >
                                1개월
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 90 ? "active" : ""}`}
                                onClick={() => setDateRange(90, 90)}
                            >
                                3개월
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-content">
                        <div className="item-input" style={{ width: "300px" }}>
                            <input
                                type="text"
                                placeholder="입력하세요."
                                name="query"
                                value={parameters.query}
                                onChange={handleParameterChange}
                            />
                        </div>
                        <div className="item-buttons">
                            <button type="button" className="btn-search" onClick={handleSearch}>
                                검색
                            </button>
                            <button
                                type="button"
                                className="btn-search"
                                onClick={() => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        ...pageFilter,
                                    }));
                                    setClientLabel({ value: null, label: "전체" });
                                }}
                            >
                                초기화
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// 계약서 등록 가이드 팝업
const ContractRegisterGuidePopup = ({ popupStatus, layer = true, onClose, formData, setFormData }) => {
    const navigate = useNavigate();

    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup contract-register-guide-popup">
                <div className="popup-content">
                    <div className="content-title">
                        <span>계약서 등록 방법</span>
                    </div>
                    <div className="way-list">
                        <div
                            className="item"
                            onClick={() => {
                                navigate(`/contract/register`);
                            }}
                        >
                            <span className="item-tit">직접 계약 등록</span>
                            {/* <span className="item-desc">
                                렌터카 또는 보험대차가 <br />
                                필요한 고객님
                            </span> */}
                        </div>

                        <div className="item" onClick={() => navigate("/order/assignment", { state: { currentTab: 2 } })}>
                            <span className="item-tit">배차 목록 선택</span>
                            {/* <span className="item-desc">
                                자동차 업계 종사자로서 <br />
                                오더를 제공할 수 있는 고객님
                            </span> */}
                        </div>
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};
